import React from 'react';
import { Box, Typography, Divider, Grid } from '@mui/material';

interface ProjectResourceCardProps {
    item: any;
}

export const ProjectResourceCard: React.FC<ProjectResourceCardProps> = ({ item }) => {

    return (
        <Box bgcolor="white" p={2} borderRadius={2} border="1px solid #e0e0e0" mb={1} boxShadow={0}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                <Box>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: '1rem', color: 'black' }}>
                        {item.DesInsumo}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#555' }}>
                        ({item.CodInsumo})
                    </Typography>
                </Box>
                <Typography variant="caption" sx={{ color: '#555' }}>
                    Unidad: {item.Unidad}
                </Typography>
            </Box>

            <Grid container spacing={1} sx={{ mb: 1, borderBottom: '1px solid #eee', pb: 1 }}>
                <Grid item xs={3} /> 
                <Grid item xs={3} sx={{ textAlign: 'right' }}><Typography variant="caption" fontWeight="bold">Cantidad</Typography></Grid>
                <Grid item xs={3} sx={{ textAlign: 'right' }}><Typography variant="caption" fontWeight="bold">Precio (S/.)</Typography></Grid>
                <Grid item xs={3} sx={{ textAlign: 'right' }}><Typography variant="caption" fontWeight="bold">Parcial</Typography></Grid>
            </Grid>

            <ResourceRow label="Meta" cant={item.MetaCantidad} prec={item.MetaPrecio} parc={item.MetaParcial} />
            <Divider sx={{ my: 0.5, opacity: 0.5 }} />

            <ResourceRow label="Prog. Acum" cant={item.ProgramadoCantidad} prec={item.ProgramadoPrecio} parc={item.ProgramadoParcial} />
            <Divider sx={{ my: 0.5, opacity: 0.5 }} />

            <ResourceRow label="Val. Acum" cant={item.ValorizadoCantidad} prec={item.ValorizadoPrecio} parc={item.ValorizadoParcial} />
            <Divider sx={{ my: 0.5, opacity: 0.5 }} />

            <ResourceRow label="Real" cant={item.RealCantidad} prec={item.RealPrecio} parc={item.RealParcial} />
            <Divider sx={{ my: 0.5, opacity: 0.5 }} />

            <ResourceRow label="Diferencia" cant={item.DiferenciaCantidad} prec={item.DiferenciaPrecio} parc={item.DiferenciaParcial} />

        </Box>
    );
};

const ResourceRow: React.FC<{ label: string, cant: any, prec: any, parc: any }> = ({ label, cant, prec, parc }) => {
    const fmt = (val: any) => {
        if (val === null || val === undefined) return '-';
        return Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    };

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={3}>
                <Typography variant="body2" sx={{ fontSize: '0.8rem', color: '#555' }}>{label}</Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: 'right' }}>
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{fmt(cant)}</Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: 'right' }}>
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{fmt(prec)}</Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: 'right' }}>
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{fmt(parc)}</Typography>
            </Grid>
        </Grid>
    )
}
